import { useRef } from 'react';
import api from 'http';
import { toast } from 'react-toastify';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';

export const useCardReader = () => {
    const abortControllerRef = useRef(new AbortController());

    const paymentStatusPool = async (intentId) => {
        const { signal } = abortControllerRef.current;
        return api
            .get(`${process.env.REACT_APP_TC_PMS}/api/PatientPayment/LongPollPaymentStatus/${intentId}`, { signal })
            .then((resp) => resp)
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    throw new Error(error);
                }
            });
    };

    const handleCancelTerminalPayment = async (stripeSettingsId, terminalId) => {
        abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
        try {
            const response = await api.get(
                `${process.env.REACT_APP_TC_PMS}/api/PatientPayment/CancelTerminalAction/${stripeSettingsId}/${terminalId}`,
                { signal: abortControllerRef.current.signal }
            );
            toast.success(response.data.responseMessage);
            return true;
        } catch (error) {
            if (error.name !== 'AbortError') {
                ErrorHandlingMessage(error);
            }
            return false;
        }
    };

    return {
        abortControllerRef,
        paymentStatusPool,
        handleCancelTerminalPayment,
    };
};